import ScheduleIcon from '@mui/icons-material/Schedule';
export const EMPTY_URL = "/";
export const SCHEDULING_URL = "/scheduling";
export const SCHEDULING_HISTORY_URL = "/scheduling-history";
export const ORGANIZATION_URL = "/organization";
export const LOGIN_URL = "/login";
export const REGISTER_URL = "/register";
export const WRONG_URL = "*";

export const EXCLUDE_LAYOUT_URLS = [LOGIN_URL,ORGANIZATION_URL ];

export const TRAVELLER_ROUTES = [
  { name: "ZAKAZIVANJE", url: SCHEDULING_URL, auth: true, roles: ["Admin"], icon: <ScheduleIcon /> },
  // { name: "ORGANIZACIJA", url: ORGANIZATION_URL, auth: true, roles: ["Admin"] },
  // {
  //   name: "ISTORIJA ZAKAZIVANJA",
  //   url: SCHEDULING_HISTORY_URL,
  //   auth: true,
  //   roles: ["Admin"],
  // },
  { name: "LOGIN", url: LOGIN_URL, auth: false, roles: [], icon: null },
 
];
